import React, { useEffect, useState } from "react";
import { Base_URL } from "../url";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

export default function InventoryDetail() {
  const { receiptId } = useParams(); // route param: /inventory/:receiptId
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch items for a receipt: GET Inventory/id?id=IR0000001
  useEffect(() => {
    if (!receiptId) return;
    const fetchDetail = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`${Base_URL}/Inventory/id`, {
          params: { id: receiptId },
        });
        const data = res.data;
        const list = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : [];
        setItems(list);
      } catch (err) {
        setError(err.message || "Failed to fetch inventory items");
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [receiptId]);

  // derive header from first item if present
  const header = items[0] ?? null;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-semibold">Inventory: {receiptId}</h1>
            <div className="text-sm text-gray-600">
              {header ? header.receiptType ?? "" : ""}
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => navigate(-1)}
              className="px-3 py-1 border rounded bg-white hover:bg-gray-50"
            >
              Back
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-4 mb-4">
         
          {!header && loading && <div>Loading header...</div>}
          {!header && !loading && <div className="text-sm text-gray-500">No header data</div>}
          {header && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div>
                <div className="text-xs text-gray-500">Inventory Receipt ID</div>
                <div>{header.inventoryReceiptId ?? header.inventoryReceiptNumber}</div>
              </div>
              <div>
                <div className="text-xs text-gray-500">Receipt Date</div>
                <div>{header.receiptDate ? header.receiptDate.split("T")[0] : header.receiptCreatedDate?.split("T")[0] ?? "-"}</div>
              </div>
              <div>
                <div className="text-xs text-gray-500">Receipt Type</div>
                <div>{header.receiptType ?? "-"}</div>
              </div>
              <div>
                <div className="text-xs text-gray-500">Created By</div>
                <div>{header.createdBy ?? "-"}</div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-white rounded-lg shadow overflow-auto">
          <table className="min-w-full text-sm divide-y">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 text-left">#</th>
                <th className="p-3 text-left">Item Code</th>
                <th className="p-3 text-left">Description</th>
                <th className="p-3 text-left">Original Qty</th>
                <th className="p-3 text-left">Qty Received</th>
                <th className="p-3 text-left">Unit</th>
                <th className="p-3 text-left">Price</th>
                <th className="p-3 text-left">Balance Quantity</th>
                 <th className="p-3 text-left">Inventory Quantity</th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y">
              {loading && (
                <tr>
                  <td colSpan={8} className="p-6 text-center">Loading...</td>
                </tr>
              )}

              {!loading && items.length === 0 && (
                <tr>
                  <td colSpan={8} className="p-6 text-center text-gray-500">No items found</td>
                </tr>
              )}

              {items.map((it, idx) => (
                <tr key={it.id ?? idx} className="hover:bg-gray-50">
                  <td className="p-3">{idx + 1}</td>
                  <td className="p-3">{it.itemCode ?? "-"}</td>
                  <td className="p-3">{it.description ?? "-"}</td>
                  <td className="p-3">{it.originalQuantity ?? "-"}</td>
                  <td className="p-3">{it.quantityReceived ?? "-"}</td>
                  <td className="p-3">{it.unit ?? "-"}</td>
                  <td className="p-3">{it.price ?? "-"}</td>
                  <td className="p-3">{it.balanceQuantity ?? "-"}</td>
                  <td className="p-3">{it.inventoryQuantity ?? "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {error && <div className="mt-4 text-sm text-red-600">Error: {error}</div>}
      </div>
    </div>
  );
}
